// extracted by mini-css-extract-plugin
module.exports = {"rule":"styles-module--rule--1Sizr","smallTop":"styles-module--smallTop--3rw_b"};